import React, { Fragment } from 'react';
import { VALIDATION_RULES } from '@constants';
import { Divider, Input, Select } from '@ui';
import { getCardMonthOptions, getCardYearsOptions } from '@utils';
import { Col, Form, Row } from 'antd';

export const CreditCardFields = ({ children }) => {
    const form = Form.useFormInstance();

    return (
        <Fragment>
            <Row gutter={16}>
                <Col span={24}>
                    <Form.Item
                        name='name'
                        rules={VALIDATION_RULES.REQUIRED}
                        onBlur={(e) => form.setFieldValue('name', e.target.value.trim())}
                    >
                        <Input label='Name on card' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col span={7}>
                    <Form.Item name='cardNumber' rules={VALIDATION_RULES.CARD_NUMBER}>
                        <Input.Number width='100%' label='Card number' prefix={null} />
                    </Form.Item>
                </Col>
                <Col span={3}>
                    <Form.Item name='cvv' rules={VALIDATION_RULES.CARD_CVV}>
                        <Input.Number label='CVV' prefix={null} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item name='expirationMonth' rules={VALIDATION_RULES.REQUIRED}>
                        <Select label='Expiration Month' options={getCardMonthOptions()} />
                    </Form.Item>
                </Col>
                <Col span={7}>
                    <Form.Item name='expirationYear' rules={VALIDATION_RULES.REQUIRED}>
                        <Select label='Expiration Year' options={getCardYearsOptions()} />
                    </Form.Item>
                </Col>
            </Row>
            <Divider margin='32px 0 24px' />
            {children}
        </Fragment>
    );
};
